import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] text-white h-screen appheader overflow-y-auto px-6 pt-6 pb-20" }
const _hoisted_2 = { class: "grid grid-cols-1" }
const _hoisted_3 = { class: "bg-[#2B2C32] rounded-lg px-5 mt-1 pb-3 mb-[90px]" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "flex gap-3 w-full items-start mb-1" }
const _hoisted_6 = { class: "w-full" }
const _hoisted_7 = { class: "input-wrapper xl:w-1/4" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "flex gap-3 w-full items-start mb-1" }
const _hoisted_13 = { class: "w-full" }
const _hoisted_14 = { class: "input-wrapper xl:w-1/4" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_OnlineMoneris = _resolveComponent("OnlineMoneris")!
  const _component_AccessToken = _resolveComponent("AccessToken")!
  const _component_InStoreMoneris = _resolveComponent("InStoreMoneris")!
  const _component_PaymentTerminals = _resolveComponent("PaymentTerminals")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_Nav),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.vg_selectedLocation.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-white font-semibold text-[24px] mt-3" }, "Online Payments", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentOnlineProcessor) = $event)),
                        class: "block rounded bg-gray-black border-none w-full text-sm text-theme-white"
                      }, [
                        _cache[2] || (_cache[2] = _createElementVNode("option", {
                          disabled: "",
                          value: "null"
                        }, "--Select--", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentProcessors, (processors) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: processors.name,
                            key: 'payment_processor_'+processors.name
                          }, _toDisplayString(processors.name), 9, _hoisted_8))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.currentOnlineProcessor]
                      ])
                    ]),
                    (_ctx.currentOnlineProcessor)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          (_ctx.currentOnlineProcessor=='moneris')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createVNode(_component_OnlineMoneris, {
                                  onDoUpdated: _ctx.doUpdated,
                                  reloadIt: _ctx.reloadIt
                                }, null, 8, ["onDoUpdated", "reloadIt"])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_AccessToken),
                                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "h-[2px] bg-theme-grey w-full" }, null, -1))
                              ]))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "text-white font-semibold text-[24px] mt-3" }, "In-Store Payments", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentInStoreProcessor) = $event)),
                        class: "block rounded bg-gray-black border-none w-full text-sm text-theme-white"
                      }, [
                        _cache[5] || (_cache[5] = _createElementVNode("option", {
                          disabled: "",
                          value: "null"
                        }, "--Select--", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentProcessors, (processors) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: processors.name,
                            key: 'payment_processor_'+processors.name
                          }, _toDisplayString(processors.name), 9, _hoisted_15))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.currentInStoreProcessor]
                      ])
                    ]),
                    (_ctx.currentInStoreProcessor)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("div", null, [
                            (_ctx.currentInStoreProcessor=='moneris')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createVNode(_component_InStoreMoneris, {
                                    onDoUpdated: _ctx.doUpdated,
                                    reloadIt: _ctx.reloadIt
                                  }, null, 8, ["onDoUpdated", "reloadIt"])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createVNode(_component_AccessToken)
                                ]))
                          ]),
                          (_ctx.vg_selectedLocation.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createVNode(_component_PaymentTerminals)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("p", { class: "text-center text-theme-red mt-3" }, "Please select a location.", -1)
              ]))]))
        ])
      ])
    ])
  ]))
}